import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import NearMissDataAccess from "src/dataAccess/nearMiss/nearMissDataAccess";

export const AddPersons = createAction<any>("Add Person Success");
export const getNearMissListSuccess = createAction<any>(
    "[NearMiss] Get NearMiss List Success"
);
export const loadingList = createAction<boolean>("[NearMiss] Loading list");
export const SetPersons = createAction<any>("[NearMiss] Set Persons");
export const setTriggerSignClearCount = createAction<any>(
    "[NearMiss] Set Trigger Sign Clear Count"
);

export const getNearMissListAsync = createAsyncThunk<any, IListType>(
    "[NearMiss] Get NearMiss List",
    async (parameter, thunkAPI) => {
        thunkAPI.dispatch(loadingList(true));

        const result = await NearMissDataAccess.NearMissList(parameter).then(
            (res) => {
                thunkAPI.dispatch(getNearMissListSuccess(res));
                thunkAPI.dispatch(loadingList(false));
                return res;
            }
        );
        return result;
    }
);

export const saveNearMissListSuccess = createAction<any>(
    "[NearMiss] Save NearMiss Success"
);

export const saveINearMissListAsync = createAsyncThunk<
    any,
    { NearMissId: any; data: any; NearMissList: Array<any> }
>("[NearMiss] Save NearMiss", async (parameter, thunkAPI) => {
    const { NearMissId, data, NearMissList } = parameter;
    thunkAPI.dispatch(loadingList(true));
    var updatedNearMissList;
    if (NearMissId == "edit") {
        let copyNearMissList = [...NearMissList];
        updatedNearMissList = (copyNearMissList ?? []).map((item, index) => {
            let copyItem = { ...item };

            if (copyItem.id == data.id) {
                copyItem = data;
            }
            return copyItem;
        });
    } else {
        let copyNearMissList = [...NearMissList];
        updatedNearMissList = [...copyNearMissList, data];
    }
    thunkAPI.dispatch(saveNearMissListSuccess(updatedNearMissList));
    thunkAPI.dispatch(loadingList(false));
    return data;
});
